// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"ff133c4c","102":"c4142892","315":"13a90e96","325":"adcb209e","465":"99b8e2dc","526":"efd93693","718":"7627128a","759":"4fcd9a27","827":"5c0ccdd6","852":"eb01c94f","940":"de07c733"}[chunkId] + ".chunk.js";
};